import type { ModuloWeb } from '../../nucleo/modulos-web';
import { Contratos } from './Contratos';
import { Planos } from './Planos';
import { Reajustes } from './Reajustes';
import { CartaoOnboarding, PaginaOnboarding } from './Onboarding';
import { i18n } from './i18n';
import { buscaAssinaturas } from './busca-global';

/** Fase 2 (W12): Assinaturas e recorrência no menu Comercial, abas Contratos, Planos (Pacote 2), Reajustes e (trilha 4) Onboarding. */
const modulo: ModuloWeb = {
  slug: 'assinaturas',
  menu: 'comercial',
  ordem: 30,
  abas: [
    { chave: 'contratos', permissao: 'assinaturas.ver', componente: Contratos },
    // Pacote 2 (onda 1a): catálogo de planos (nome, recorrência, itens e preço).
    { chave: 'planos', permissao: 'assinaturas.ver', componente: Planos },
    { chave: 'reajustes', permissao: 'assinaturas.ver', componente: Reajustes },
    // Trilha 4 (ciclo do cliente): configuração do ciclo e modelo do onboarding de cliente.
    { chave: 'onboarding', permissao: 'assinaturas.ver', componente: PaginaOnboarding },
  ],
  // Trilha 4: acompanhamento do onboarding na ficha do cliente.
  cartaoNaFichaCliente: CartaoOnboarding,
  i18n,
  // Lista de 30/10 (item 10): grupos da busca da barra superior.
  buscaGlobal: buscaAssinaturas,
};

export default modulo;
